import {
  Box,
  DialogContent,
  DialogTitle,
  Divider,
  Grid,
  Paper,
  Typography,
  useMediaQuery,
  useTheme,
} from '@material-ui/core';
import { RouteComponentProps } from '@reach/router';
import { Link, navigate } from 'gatsby';
import React, { useContext } from 'react';
import Backdrop from '../../../components/backdrop/Backdrop';
import Buttons from '../../../components/buttons';
import routes from '../../../routes';
import IconExpand from '../../../components/pge-plus-common/static/Expand.svg';
import IconInstaller from '../../../components/pge-plus-common/static/installerIcon.svg';
import IconChargerLevel2 from '../../../components/pge-plus-common/static/evChargerIcon.svg';
import useContentMgmt from '../../../hooks/useContentMgmt';
import microcopyGroupIds from '../../../components/pge-plus-common/microcopyGroupIds';
import { featureFlagsContext } from '../../../providers/FeatureFlagsProvider';

const GetStarted: React.FC<RouteComponentProps> = (
  props: RouteComponentProps,
) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('xs'));
  const { content, isContentLoading } = useContentMgmt(
    microcopyGroupIds.PGE_PLUS_CHOOSE_ACCOUNT,
  );
  const { isPGEPlusRebateOnlyEnabled } = useContext(featureFlagsContext);

  if (isContentLoading) {
    return <Backdrop forceOpen />;
  }

  return (
    <Box padding={isPGEPlusRebateOnlyEnabled ? 20 : theme.spacing(20, 40)}>
      <Paper
        css={{
          [theme.breakpoints.down('xs')]: {
            maxWidth: '600px !important',
            width: '100%',
            position: 'fixed',
            bottom: 0,
            left: 0,
          },
        }}
      >
        <DialogTitle css={{ padding: '24px 24px 0' }}>
          <Grid
            container
            css={{
              justifyContent: 'end',
            }}
          ></Grid>
        </DialogTitle>
        <DialogContent
          css={{
            padding: '8px 24px 40px',
            [theme.breakpoints.down('xs')]: {
              padding: '0 24px 40px',
            },
          }}
        >
          <Box>
            <Box>
              <Typography variant={'h1'} css={{ marginBottom: '20px' }}>
                {content.get('LET_GET_STARTED')}
              </Typography>
            </Box>
            <Box
              css={{
                display: 'flex',
                [theme.breakpoints.down('sm')]: {
                  flexDirection: 'column',
                },
              }}
            >
              <Box
                css={{ padding: theme.spacing(2), width: '100%' }}
                justifyContent={'center'}
                display={'flex'}
                alignItems={'flex-start'}
              >
                <Grid
                  container
                  direction="column"
                  css={{
                    justifyContent: 'space-between',
                    height: '100%',
                  }}
                >
                  <Grid container direction="row">
                    <Grid item xs={2} md={2}>
                      <IconChargerLevel2 height={58} width={52} />
                    </Grid>
                    <Grid
                      item
                      xs={1}
                      md={1}
                      css={{
                        display: 'flex',
                        alignItems: 'center',
                      }}
                    >
                      <IconExpand />
                    </Grid>
                    <Grid item xs={3} md={3}>
                      <IconInstaller />
                    </Grid>
                    <Grid item xs={12}>
                      <Typography variant={'h2'}>
                        {content.get('NEED_CHARGER_SUBTEXT')}
                      </Typography>
                    </Grid>
                  </Grid>

                  <Grid item>
                    <Buttons
                      type="button"
                      color={'primary'}
                      fullWidth
                      variant="contained"
                      onClick={() =>
                        navigate(
                          `${routes.PGE_PLUS_EV_CHARGERS_CHOOSE_ACCOUNT}?suppliedByCustomer=false`,
                        )
                      }
                      css={{
                        fontSize: '18px',
                        borderRadius: '30px',
                        marginTop: '20px',
                      }}
                    >
                      {content.get('NEED_A_CHARGER')}
                    </Buttons>
                  </Grid>
                </Grid>
                {!isMobile && (
                  <Divider
                    orientation="vertical"
                    flexItem
                    css={{ margin: theme.spacing(1, '10px', 0, '10px') }}
                  />
                )}
              </Box>
              <Box
                css={{ padding: theme.spacing(2), width: '100%' }}
                justifyContent={'center'}
                display={'flex'}
                alignItems={'flex-start'}
              >
                <Grid
                  container
                  direction="column"
                  css={{ justifyContent: 'space-between', height: '100%' }}
                >
                  <Grid container direction="row">
                    <Grid item xs={12}>
                      <IconInstaller />
                    </Grid>
                    <Grid item xs={12}>
                      <Typography variant={'h2'}>
                        {content.get('HAVE_CHARGER_SUBTEXT')}
                      </Typography>
                    </Grid>
                  </Grid>
                  <Grid item>
                    <Buttons
                      type="button"
                      fullWidth
                      color={'primary'}
                      variant="contained"
                      onClick={() =>
                        navigate(
                          `${routes.PGE_PLUS_EV_CHARGERS_CHOOSE_ACCOUNT}?suppliedByCustomer=true`,
                        )
                      }
                      css={{
                        fontSize: '18px',
                        borderRadius: '30px',
                        marginTop: '20px',
                      }}
                    >
                      {content.get('HAVE_A_CHARGER')}
                    </Buttons>
                  </Grid>
                </Grid>
                {!isMobile && isPGEPlusRebateOnlyEnabled && (
                  <Divider
                    orientation="vertical"
                    flexItem
                    css={{ margin: theme.spacing(1, '10px', 0, '10px') }}
                  />
                )}
              </Box>
              {isPGEPlusRebateOnlyEnabled && (
                <Box
                  css={{ padding: theme.spacing(2), width: '100%' }}
                  justifyContent={'center'}
                  display={'flex'}
                  alignItems={'flex-start'}
                >
                  <Grid
                    container
                    direction="column"
                    css={{ justifyContent: 'space-between', height: '100%' }}
                  >
                    <Grid container direction="row">
                      <Grid item xs={12}>
                        <IconChargerLevel2 height={58} width={52} />
                      </Grid>
                      <Grid item xs={12}>
                        <Typography variant={'h2'}>
                          {content.get('ALREADY_HAVE_CHARGER_NEED_REBATES')}
                        </Typography>
                      </Grid>
                    </Grid>
                    <Grid item>
                      <Buttons
                        type="button"
                        fullWidth
                        color={'primary'}
                        variant="contained"
                        onClick={() =>
                          navigate(routes.PGE_PLUS_REBATE_ONLY_HOME)
                        }
                        css={{
                          fontSize: '18px',
                          borderRadius: '30px',
                          marginTop: '20px',
                        }}
                      >
                        {content.get('CHECK_QUALIFICATIONS')}
                      </Buttons>
                    </Grid>
                  </Grid>
                </Box>
              )}
            </Box>
          </Box>
        </DialogContent>
      </Paper>
    </Box>
  );
};

export default GetStarted;
